import requests from "../util";

const URL = "card-token";

const cardTokenApi = {
    create: (data: {
        tokenize: {
            holderName: string;
            number: string;
            cvv: string;
            expiration: string;
            buyerUuid: string;
            checkZeroDollar?: boolean;
        };
        userGatewayId: string;
    }) => requests.post(URL, data),
};

export default cardTokenApi;
